import type { ApiRoute, NoBody, NoPathParams } from "../../api"
import type { RoofColorOptionView } from "../../common/colors/roofColor/RoofColorOptionView"

export interface GetRoofColorOptionsQueryParams {
	"model-year": string
	"order-type-code": string
}

export const getRoofColorOptionsRoute: ApiRoute<
	NoPathParams,
	GetRoofColorOptionsQueryParams,
	NoBody,
	RoofColorOptionView[]
> = {
	buildUrl: () => "/colors/roof-color/options",
	method: "get",
	path: "/colors/roof-color/options",
}
